import { Audit } from './audit.model';

export enum NoteCategory {
  AGENT_FEEDBACK = 'Agent Feedback',
  AGENT_INFORMATION = 'Agent Information',
  DESCRIPTION_PREFERENCES = 'Description Preferences',
  OPPORTUNITIES = 'Opportunities',
  PHOTOS_PREFERENCES = 'Photos Preferences',
  TEMPLATE_PREFERENCES = 'Template Preferences',
  OTHER = 'Other',
}

export class Note {
  /** Unique identifier for the note */
  _id?: string;

  /** Full name of the user who wrote the note */
  author: string;

  /** The text of the note */
  text: string;

  /** Category of the note (string matching NoteCategory enum values) */
  category: string;

  /** Date the notification was generated. Used as the secondary sort order of the notifications in the UI */
  audit?: Audit;

  constructor(input?: Partial<Note>) {
    Object.assign(this, input);
    if (input?.audit) {
      this.audit = new Audit(input.audit);
    }
  }
}
